import { useEffect, useState } from "react";
import triggerBeacon from "./triggerBeacon";
import { BEACON } from "@asosteam/asos-web-adverts-sdk";

const useGetAdverts = ({
  sdkInstance,
  app,
  placement,
  requestSponsoredProducts,
  requestDisplayAdverts,
  breakCache,
  parameters,
  handleErrors
}) => {
  const [advertsResponse, setAdvertsResponse] = useState({});

  useEffect(() => {
    const awaitSdkAndFireGetAdverts = async () => {
      if (sdkInstance) {
        const response = await sdkInstance.getAdverts({
          options: {
            app,
            placement,
            requestSponsoredProducts,
            requestDisplayAdverts,
            breakCache
          },
          parameters
        });

        if (Object.keys(response).length) {
          triggerBeacon(
            sdkInstance,
            app,
            placement,
            BEACON.ON_LOAD,
            handleErrors
          );
        }

        setAdvertsResponse(response);
      }
    };
    awaitSdkAndFireGetAdverts();
  }, [
    sdkInstance,
    app,
    placement,
    requestDisplayAdverts,
    requestSponsoredProducts,
    breakCache,
    parameters,
    handleErrors
  ]);

  return advertsResponse;
};

export default useGetAdverts;
